module.exports = __webpack_public_path__ + "static/media/youtube-logo.7a6d622f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/youtube-logo.png
// module id = 83
// module chunks = 0